import React from 'react'
import MUITooltip, { TooltipProps } from '@mui/material/Tooltip'
import styled from 'styled-components'

import { SIZES, BORDER_RADIUS } from '~/common/globalStyles'

type StyledTooltipProps = Omit<TooltipProps, 'children' | 'placement'> & {
  children?: React.ReactNode
  placement?: TooltipProps['placement'] | string
}

const Tooltip = styled((props: StyledTooltipProps) => {
  const { placement, ...rest } = props
  return (
    <MUITooltip
      classes={{
        tooltip: 'tooltip',
        popper: props.className,
        arrow: 'arrow',
      }}
      {...rest}
      placement={placement as TooltipProps['placement']}
    >
      <span>{props.children}</span>
    </MUITooltip>
  )
})`
  & .tooltip {
    font-size: ${SIZES.medium};
    font-family: inherit;
    background-color: ${({ theme }) => theme.palette.background.paper};
    color: ${({ theme }) => theme.palette.grey[800]};
    padding: ${SIZES.small} ${SIZES.xl};
    opacity: 1;
    border-radius: ${BORDER_RADIUS}px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
    max-width: 310px;
  }
  & .arrow::before {
    background-color: ${({ theme }) => theme.palette.background.paper};
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  }
`
export default Tooltip
